import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import icon from "assets/imgs/icon.png";

import { newId } from "utils/Utils.js";
import Firebase from "Firebase.js";

export default function CriarTag() {
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");

  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nome && descricao) {
      setLoading(true);
      const id = newId();
      await Firebase.fire.firestore().collection("tags").doc(id).set({
        id: id,
        nome: nome,
        descricao: descricao,

        createdAt: Date.now(),
      });
      setLoading(false);
      alert("Tag criada com sucesso!");
      setNome("");
      setDescricao("");
    } else {
      alert("Preencha todos os campos.");
    }
  };

  const handleNomeChange = (e) => {
    setNome(e.target.value);
  };

  const handleDescChange = (e) => {
    setDescricao(e.target.value);
  };

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Criar Tag</Typography>
          <Divider />
        </Grid>

        <Grid item xs={10} style={{ textAlign: "center" }}>
          <form onSubmit={submit}>
            <Paper elevation={3} style={{ paddingTop: "15px" }}>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Nome da Tag"
                    type="text"
                    autoFocus
                    value={nome}
                    onChange={handleNomeChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Descrição"
                    type="text"
                    value={descricao}
                    multiline
                    minRows={3}
                    maxRows={6}
                    color="secondary"
                    onChange={handleDescChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                  >
                    {!loading ? "Enviar" : <CircularProgress color="primary" />}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
